import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { PortalProfileService } from '../pages/portal-profile/portal-profile.service';
import { IGenericAttributeService } from 'src/shared-app-portal/interfaces/i-generic-attribute-service';
import { Injectable } from '@angular/core';
import { AttributeEditorMode } from 'src/app/shared/models/attributes/attributeEditorMode';
import { AttributeWrite } from 'src/app/shared/models/attributes/attributeWrite';
import { ComplexAttributeWrite } from 'src/app/shared/models/attributes/complexAttributeWrite';
import { getParsedError } from 'src/app/shared/services/error-handler-factory.service';

@Injectable({
  providedIn: 'root'
})
export class PortalGenericAttributeFactoryService {
  constructor(public portalProfileService: PortalProfileService) {}

  public BuildForPersonOnProfile = (
    personId: string,
    attributeDefinition: AttributeDefinition
  ): IGenericAttributeService =>
    new UpdatePersonAttributeService(personId, attributeDefinition, this.portalProfileService);
}

export class UpdatePersonAttributeService {
  constructor(
    public personId: string,
    public attributeDefinition: AttributeDefinition,
    public portalProfileService: PortalProfileService
  ) {
    this.entityId = personId;
    this.mode = AttributeEditorMode.PersonDetails;
  }

  private onUpdate = async (message: string) => {
    this.portalProfileService.openSnackBar(message, true);
    await this.portalProfileService.getProfile();
  };

  updateAttribute = async (attribute: AttributeWrite) => {
    const result = await this.portalProfileService.updateAttribute(
      this.attributeDefinition.id,
      attribute
    );
    if (result) {
      await this.onUpdate('custom field value has been updated.');
      return true;
    }
    return false;
  };

  updateAttributeComplex = (attributes: ComplexAttributeWrite[]) =>
    this.portalProfileService
      .addOrUpdateComplexAttribute(this.attributeDefinition.id, attributes)
      .subscribe(
        async () => {
          await this.onUpdate('custom field value has been updated.');
        },
        (error) => {
          this.portalProfileService.openSnackBar(getParsedError(error).message, false);
        }
      );

  deleteAttribute = () =>
    this.portalProfileService.deleteAttribute(this.attributeDefinition.id).subscribe(
      async () => {
        await this.onUpdate('custom field value has been deleted.');
      },
      (error) => {
        this.portalProfileService.openSnackBar(getParsedError(error).message, false);
      }
    );

  mode: AttributeEditorMode;
  entityId: string;
}
